const mapFailures = (failures)=>{
    return failures.map((failure)=>failure.__typename || failure.message
    );
};

export { mapFailures };
//# sourceMappingURL=map-failures.js.map
